import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { vendorPaymentStatus } from "../lib/api";

export default function PaymentResult({ outcome }) {
  const nav = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const sessionId = params.get("session_id");
  const [state, setState] = useState(outcome === "cancel" ? "cancel" : "checking");
  const [slug, setSlug] = useState(params.get("slug") || "");

  useEffect(() => {
    if (outcome !== "success" || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const r = await vendorPaymentStatus(sessionId);
        if (r.slug) setSlug(r.slug);
        if (r.payment_status === "paid") return setState("paid");
        if (["failed", "expired"].includes(r.payment_status)) return setState("failed");
      } catch {
        /* keep polling */
      }
      if (++tries < 8) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [outcome, sessionId]);

  useEffect(() => {
    if (state === "paid") {
      const t = setTimeout(() => nav("/vendor"), 2500);
      return () => clearTimeout(t);
    }
  }, [state, nav]);

  return (
    <div className="min-h-screen bg-white text-black font-mono">
      <Seo title="payment" description="TerminalValue.io payment" path="/payment" noindex />
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-10 text-[13px]" data-testid="payment-page">
        {state === "checking" && <p data-testid="payment-checking">confirming your payment…</p>}
        {state === "paid" && (
          <div data-testid="payment-paid">
            <h1 className="text-xl font-bold border-b border-black pb-2">{">"}_ you&apos;re on Starter</h1>
            <p className="mt-3">
              {slug && <>Your listing <Link to={`/tool/${slug}`} className="tv-link">/tool/{slug}</Link> is upgraded. </>}
              Taking you to your <Link to="/vendor" className="tv-link">vendor dashboard</Link> to set up your button and page…
            </p>
          </div>
        )}
        {state === "cancel" && (
          <div data-testid="payment-cancel">
            <h1 className="text-xl font-bold border-b border-black pb-2">{">"}_ checkout cancelled</h1>
            <p className="mt-3">Nothing was charged. <Link to={slug ? `/claim/${slug}` : "/vendor"} className="tv-link">back to your listing</Link></p>
          </div>
        )}
        {(state === "failed" || state === "timeout") && (
          <div data-testid="payment-failed">
            <h1 className="text-xl font-bold border-b border-black pb-2">{">"}_ payment not confirmed</h1>
            <p className="mt-3">
              {state === "failed" ? "The payment did not go through." : "We couldn't confirm it yet — it can take a minute."}{" "}
              Check your <Link to="/vendor" className="tv-link">vendor dashboard</Link> or <Link to="/contact" className="tv-link">contact us</Link>.
            </p>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
